import { EAnalyticsEvents } from '@/_analytic/_types';
import { sendAnalyticsEvent } from '@/_analytic/send-analytics-event';
import { TFaqClickEventParams } from './_types';

export const faqClickEvent = (params: TFaqClickEventParams) => {
  sendAnalyticsEvent({
    name: EAnalyticsEvents.FAQ_CLICK,
    params,
  });
};
